import React from 'react'
import { WidgetGuard } from 'features/types'
import WaveLoading from 'components/share/WaveLoading'
import { useDashboardWidgetData } from 'hooks/useWidgetState'
import { DocumentRetrievalResult } from 'schemas/DocumentRetrievalResultSchema'
import { SentenceRetrievalResult } from 'schemas/SentenceRetrievalResultSchema'

const LoadMoreGuard: WidgetGuard = ({ widgetId, children }) => {
  const widgetExtraData = useDashboardWidgetData<DocumentRetrievalResult | SentenceRetrievalResult>(
    widgetId
  )
  if (!widgetExtraData) return <WaveLoading />

  const isSuccessful = widgetExtraData.loadMoreStatus === 'succeeded'
  const hasData = widgetExtraData.data !== undefined

  if (!isSuccessful && !hasData) return <WaveLoading />

  return children
}

export default LoadMoreGuard
